import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  getProductHref,
  getProductPath,
  getRouterType
} from 'common/helpers/routerHelper';
import { recordEvent } from 'redux/analytics/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const ProductLink = (props) => {
  const { children, linkType, product, ariaHidden, tabIndex } = props;
  const dispatch = useDispatch();
  const { t } = useLocalization();

  const handleClick = () => {
    dispatch(recordEvent('productClick', product));
  };

  switch (linkType) {
    case 'Window': {
      return (
        <a
          href={getProductHref(`/${product.slug}`)}
          onClick={handleClick}
          aria-hidden={ariaHidden}
          tabIndex={tabIndex}
        >
          {children}
        </a>
      );
    }
    case 'Ajax': {
      const routerType = getRouterType();
      if (routerType === 'Hash') {
        return (
          <a
            href={getProductHref(`/${product.slug}`)}
            onClick={handleClick}
            aria-hidden={ariaHidden}
            tabIndex={tabIndex}
          >
            {children}
          </a>
        );
      }

      return (
        <Link
          to={getProductPath(`/${product.slug}`)}
          onClick={handleClick}
          aria-hidden={ariaHidden}
          tabIndex={tabIndex}
        >
          {children}
        </Link>
      );
    }
    default: {
      return t('general.errorMessages.invalidProductLinkType');
    }
  }
};

export default ProductLink;
